import { getJpdViewsServicePathPrefix } from '@jira/polaris__lib-jpd-views-service/src/index.tsx';
import { performDeleteRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

export const deleteView = (viewId: string): Promise<void> =>
	performDeleteRequest(`${getJpdViewsServicePathPrefix()}/v1/views/${viewId}`);
